import * as React from "react";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import {accessGroupServiceColumns} from "utils/DataBase";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import TablePagination from "@mui/material/TablePagination";
import {useEffect, useState} from "react";
import {useTheme} from "@emotion/react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import PropTypes from "prop-types";
import {
    getGroupPermissionService,
    postNewPermissionService,
    deletePermissionService,
    getServiceList
} from 'api/Api';
import Alert, {useAlert} from "components/snacks/Alert";
import CircularProgress from "@mui/material/CircularProgress";

function TablePaginationActions(props) {
    const theme = useTheme();
    const {count, page, rowsPerPage, onPageChange} = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };
    useEffect(() => {
        const selector = document.querySelector('#serviceAccessPagination p');
        if (selector) {
            selector.classList.add('yekan-font');
            selector.innerHTML = 'ردیف در هر صفحه';
        }
    }, []);

    return (
        <Box sx={{flexShrink: 0, ml: 2.5}}>
            <IconButton
                sx={{mr: 2.5}}
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon/> : <LastPageIcon/>}
            </IconButton>

            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? (
                    <KeyboardArrowLeft/>
                ) : (
                    <KeyboardArrowRight/>
                )}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? (
                    <KeyboardArrowRight/>
                ) : (
                    <KeyboardArrowLeft/>
                )}
            </IconButton>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon/> : <FirstPageIcon/>}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired
};

const AccessGroupService = ({group_id, group_name, closeModal}) => {
    const [len, setLen] = useState(0);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [loading, setLoading] = useState(false);
    const [services, setServices] = useState([]);
    const [serviceNumber, setServiceNumber] = useState('');
    const [acceptDelete, setAcceptDelete] = useState(0);
    const [userServices, setUserServices] = useState([]);

    const alert_timeout = 10000;
    const alertStore = useAlert(alert_timeout);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const getAccessServices = () => {
        setLoading(true);
        getGroupPermissionService(group_id, (isOk, data) => {
            if (isOk) {
                setServices(data.services);
                setLen(data.services.length);
            } else {
                alertStore.AddAlert({
                    key: '400',
                    message: data,
                    severity: 'error',
                    auto_hide: true
                });
            }
            setLoading(false);
        })
        getServiceList( (isOk, data) => {
            if (isOk) {
                setUserServices(data.services);
            } else {
                alertStore.AddAlert({
                    key: '400',
                    message: data,
                    severity: 'error',
                    auto_hide: true
                });
            }
            setLoading(false);
        })
    }

    const addService = (e) => {
        e.preventDefault();
        if (!serviceNumber) {
            return alertStore.AddAlert({
                key: '400',
                message: "لطفا شماره سرویس را وارد کنید",
                severity: 'error',
                auto_hide: true
            });
        }
        setLoading(true);
        const formData = new FormData();
        formData.append('group_id', group_id);
        formData.append('service_no', serviceNumber);
        postNewPermissionService(formData, (isOk, data) => {
            if (!isOk) {
                alertStore.AddAlert({
                    key: '400',
                    message: data.msg,
                    severity: 'error',
                    auto_hide: true
                });
                setLoading(false);
            } else {
                alertStore.AddAlert({
                    key: '400',
                    message: data.msg,
                    severity: 'success',
                    auto_hide: true
                });
            }
            getAccessServices();
            setServiceNumber('');
        })
    }

    const handleDelete = (row) => {
        setLoading(true);
        deletePermissionService(row.id, (isOk, data) => {
            if (!isOk) {
                alertStore.AddAlert({
                    key: '400',
                    message: data.msg,
                    severity: 'error',
                    auto_hide: true
                });
                setLoading(false);
            } else {
                alertStore.AddAlert({
                    key: '400',
                    message: data.msg,
                    severity: 'success',
                    auto_hide: true
                });
            }
            getAccessServices();
            setAcceptDelete(0);
        })
    }

    useEffect(() => {
        getAccessServices()
    }, []);

    useEffect(() => {
        const selector = document.querySelector('#serviceAccessPagination p');
        if (selector) {
            selector.classList.add('yekan-font');
            selector.innerHTML = 'ردیف در هر صفحه';
        }
    }, [services, loading]);

    return (
        <>
            <div className="modal fade show d-block" id="submitModal">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5"
                                id="exampleModalLabel">
                                <span>سرویس های گروه دسترسی</span>
                                <span>"{group_name}"</span>
                            </h1>
                            <button type="button" className="btn-close"
                                    onClick={closeModal}></button>
                        </div>
                        {loading ? <>
                            <div className="modal-body">
                                <div
                                    className={"d-flex justify-content-center align-items-center"}>
                                    <Box sx={{display: 'flex', marginLeft: '15px'}}>
                                        <CircularProgress/>
                                    </Box>
                                </div>
                            </div>
                        </> : <>
                            <form className="d-flex justify-content-around align-items-center px-4 pt-4" method={'post'}
                                  onSubmit={addService}>
                                <div className={'w-50'}>
                                    <label className={'w-100 mb-7'}>
                                          <span className={''}>
                                            افزودن سرویس
                                          </span>
                                        <select
                                          required
                                          onChange={(e) => setServiceNumber(e.target.value)}
                                          value={serviceNumber}
                                          // defaultValue={1}
                                          className={'d-block w-100 mt-2'}
                                          style={{
                                              border: 'none',
                                              borderBottom: '2px solid #e7e4e4',
                                              backgroundColor: '#f5f8fa',
                                              color: '#5e6278',
                                              transition: 'color .2s ease,background-color .2s ease',
                                              minHeight: 'calc(1.5em + 1.65rem + 2px)',
                                              padding: '0.825rem 1.5rem',
                                              fontSize: '1.1em',
                                              borderRadius: '0.475rem'
                                          }}
                                        >
                                            <option value="">-</option>
                                            {
                                                userServices.map((cat, index) => (
                                                  <option key={index} value={cat.id}>
                                                      {cat.product_name + (cat.ip ? ' - ' + cat.ip : '') + (cat.user_label ? ' - ' + cat.user_label : '')}
                                                  </option>
                                                ))
                                            }
                                        </select>
                                    </label>
                                </div>
                                <button type="submit" className={'btn btn-success ms-5'}>افزودن</button>
                            </form>
                            <hr />
                            {services.length ? <>
                                <TableContainer className="d-none d-md-block">
                                    <Table stickyHeader aria-label="sticky table">
                                        <TableHead sx={{ BackgroundColor: '#eaeaea' }}>
                                            <TableRow>
                                                {accessGroupServiceColumns?.map((column) => (
                                                  <TableCell
                                                    key={column.id}
                                                    align={column.align}
                                                    style={{
                                                        minWidth: column.minWidth,
                                                        fontFamily: 'yekan',
                                                        fontSize: '1em',
                                                        whiteSpace: 'nowrap'
                                                    }}
                                                  >
                                                  {column.label}
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {services &&
                                                services
                                                    .slice(
                                                        page * rowsPerPage,
                                                        page * rowsPerPage + rowsPerPage
                                                    )
                                                    ?.map((row, index) => {
                                                        return (
                                                            <TableRow
                                                                hover
                                                                role="checkbox"
                                                                tabIndex={-1}
                                                                key={index}
                                                                style={{
                                                                    backgroundColor:
                                                                        index % 2 === 0 ? '#f3f3f3' : ''
                                                                }}
                                                            >
                                                                {accessGroupServiceColumns?.map((column) => {
                                                                    const value = row[column.id];
                                                                    return (
                                                                        <TableCell
                                                                            key={column.id}
                                                                            align={column.align}
                                                                            sx={{
                                                                                fontFamily: 'yekan !important'
                                                                            }}
                                                                        >
                                                                            {column.id === 'id' && (
                                                                                <span>{index + 1}</span>
                                                                            )}
                                                                            {column.id === 'service_name' && (
                                                                                    <span>{value ? value : '-'}</span>
                                                                                )}
                                                                            {column.id === "action" && (
                                                                                <>
                                                                                    {acceptDelete === row.id ? <>
                                                                                        <button
                                                                                            onClick={() => setAcceptDelete(0)}
                                                                                            className={'btn btn-sm btn-warning'}>
                                                                                            انصراف
                                                                                        </button>
                                                                                        <button
                                                                                            onClick={() => handleDelete(row)}
                                                                                            className={"btn btn-sm btn-danger ms-1"}>
                                                                                            حذف کن
                                                                                        </button>
                                                                                    </> : <button
                                                                                        onClick={() => setAcceptDelete(row.id)}
                                                                                        className={"btn btn-sm btn-danger ms-1"}>
                                                                                        حذف
                                                                                    </button>}
                                                                                </>
                                                                            )}
                                                                            {column.id !== 'id' &&
                                                                                column.id !== 'action' &&
                                                                                column.id !== 'service_name' && (
                                                                                    <span>{value}</span>
                                                                                )}
                                                                        </TableCell>
                                                                    );
                                                                })}
                                                            </TableRow>
                                                        );
                                                    })}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <TableContainer className="d-none d-md-block">
                                    <Table>
                                        <TableHead/>
                                        <TableBody>
                                            <TableRow>
                                                <TablePagination
                                                    id={'serviceAccessPagination'}
                                                    rowsPerPageOptions={[
                                                        5,
                                                        10,
                                                        25,
                                                        {
                                                            label: 'All',
                                                            value: 1000
                                                        }
                                                    ]}
                                                    colSpan={4}
                                                    count={len}
                                                    rowsPerPage={rowsPerPage}
                                                    page={page}
                                                    SelectProps={{
                                                        inputProps: {
                                                            'aria-label': 'rows per page'
                                                        },
                                                        native: true
                                                    }}
                                                    onPageChange={handleChangePage}
                                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                                    ActionsComponent={TablePaginationActions}
                                                    style={{display: 'flex'}}
                                                />
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </> : <div className={'alert alert-warning text-center'}>اعضایی ثبت نشده است</div>}
                        </>}
                    </div>
                </div>
            </div>
            <div className="modal-backdrop fade show" onClick={closeModal}></div>
            {
                <Alert
                    alerts={alertStore.alert}
                    close={alertStore.RemoveAlert}
                    timeout={alert_timeout}
                />
            }
        </>
    )
}

export default AccessGroupService;
